import React from 'react';
import { HardHat, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-800 text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <HardHat className="h-6 w-6 text-yellow-400" />
              <h3 className="text-xl font-bold">Asphalt Calculator</h3>
            </div>
            <p className="text-slate-300 mb-4">
              Professional tool for estimating asphalt pavement tonnage required for construction projects.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-slate-300">
              <li><a href="#calculator" className="hover:text-yellow-400 transition-colors">Calculator</a></li>
              <li><a href="#features" className="hover:text-yellow-400 transition-colors">Features</a></li>
              <li><a href="#about" className="hover:text-yellow-400 transition-colors">About</a></li>
              <li><Link to="/privacy" className="hover:text-yellow-400 transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="flex items-center text-slate-300">
              <Mail className="h-4 w-4 mr-2 text-yellow-400" />
              <span>info@asphaltcalculator.online</span>
            </div>
          </div>
        </div>
        
        <div className="border-t border-slate-700 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 mb-4 md:mb-0">
              © {currentYear} Asphalt Calculator. All rights reserved.
            </p>
            <div className="flex space-x-6 text-slate-400">
              <Link to="/privacy" className="hover:text-yellow-400 transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-yellow-400 transition-colors">Terms of Service</Link>
              <Link to="/cookies" className="hover:text-yellow-400 transition-colors">Cookie Policy</Link>
              <Link to="/disclaimer" className="hover:text-yellow-400 transition-colors">Disclaimer</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};